module.exports = __webpack_public_path__ + "img/Jump Casting63.a71ed08b.jpg";